import {
  BUSINESS_UNITS,
  MANAGEABLE_BUSINESS_UNITS,
  BUSINESS_UNIT,
  BUSINESS_UNIT_CUSTOM_DOMAIN
} from '@/store/actions/businessUnits.actions';

const initialState = {
  business_units: [],
  manageable_business_units: [],
  current_business_unit: null,
  business_unit_custom_domains: {}, // Keyed by business_unit_id
  loading: false,
  error: null
};

export default function businessUnits(state = initialState, action) {
  switch (action.type) {
    case BUSINESS_UNITS:
      return {
        ...state,
        business_units: action.payload.business_units || [],
        loading: false,
        error: null
      };

    case MANAGEABLE_BUSINESS_UNITS:
      return {
        ...state,
        manageable_business_units: action.payload.business_units || [],
        loading: false,
        error: null
      };

    case BUSINESS_UNIT:
      return {
        ...state,
        current_business_unit: action.payload.business_unit,
        loading: false,
        error: null
      };

    case BUSINESS_UNIT_CUSTOM_DOMAIN:
      return {
        ...state,
        business_unit_custom_domains: {
          ...state.business_unit_custom_domains,
          [action.payload.business_unit_id]: action.payload.custom_domain
        },
        loading: false,
        error: null
      };

    default:
      return state;
  }
}
